// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"1ea007b7","117":"3cc10131","172":"c51beb2b","241":"7e04a17f","298":"ac97803b","361":"18dcfba7","505":"6f52bf58","506":"9e7da1fa","513":"9191368a","524":"5b6a5687","657":"1692036f","741":"e4f9d548","832":"bfc43bf1","886":"b5ca7c4f","936":"4319a419","944":"72e10c47"}[chunkId] + ".chunk.js";
};